"use strict";
/**
 * Creator Studio Types
 * Menu Groups, Public Shares, Menu Board Generation, and Mini Menu Studio
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ASPECT_RATIO_DIMENSIONS = exports.BOARD_TYPE_PROMPTS = exports.SEASON_PROMPTS = void 0;
// ============================================
// SEASONAL THEMES
// ============================================
exports.SEASON_PROMPTS = {
    spring: "Light pastel colors, cherry blossoms, fresh green leaves, soft pink and mint accents, bright and airy feel",
    summer: "Bright vibrant colors, tropical elements, sunshine yellow, ocean blue accents, refreshing and energetic",
    autumn: "Warm earth tones, falling leaves, pumpkin orange, burgundy and gold accents, cozy rustic feel",
    winter: "Cool blue tones, snowflakes, silver and white, cozy warm lighting, elegant and festive",
    holiday: "Festive red and green, gold ornaments, twinkling lights, celebratory feel, warm and inviting",
    neutral: "Clean modern design, white background, subtle shadows, professional minimalist look"
};
exports.BOARD_TYPE_PROMPTS = {
    board: "Create a professional menu board layout suitable for display in a cafe or restaurant. Arrange items in a clear, readable grid format with elegant typography.",
    social: "Create an eye-catching social media post optimized for engagement. Use bold typography, attractive food presentation, and modern design trends."
};
// ============================================
// ASPECT RATIO DIMENSIONS
// ============================================
exports.ASPECT_RATIO_DIMENSIONS = {
    '1:1': { width: 1080, height: 1080 }, // Instagram square
    '4:5': { width: 1080, height: 1350 }, // Instagram portrait
    '16:9': { width: 1920, height: 1080 }, // Menu board, YouTube
    '9:16': { width: 1080, height: 1920 }, // Stories, TikTok, Reels
    'custom': null // User-defined
};
//# sourceMappingURL=creator.js.map